const PROPERTY_TYPE_GROUP = {

  id: "property_type_group",
  type: "dropdown",
  props: {
    dropdownProps: {
      label: "Property Type",
      buttonProps: {
        className: "property_type_group",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      { label: "HDB", value: "HDB" },
      { label: "Apartment / Condo", value: "Non-Landed" },
      { label: "Landed", value: "Landed" },
      { label: "Office", value: "Office" },
      { label: "Retail", value: "Retail" },
      { label: "Industrial", value: "Industrial" },
      { label: "Land", value: "Land" },
    ]
  }

}

const COL_PROPERTY_TYPE_GROUP = {

  id: "col_property_type_group",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [PROPERTY_TYPE_GROUP]

}

const COL_MODAL_PROPERTY_TYPE_GROUP = {

  id: "col_property_type_group",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [PROPERTY_TYPE_GROUP]

}

export { PROPERTY_TYPE_GROUP, COL_PROPERTY_TYPE_GROUP, COL_MODAL_PROPERTY_TYPE_GROUP };
